module.exports = __webpack_public_path__ + "static/media/channels02.b0bf96eb.JPG";